export interface Release {
  version: string;
  date: string;
  features: string[];
  fixes?: string[];
  major?: boolean;
}

export const Releases: Release[] = [
  {
    version: '1.6.0',
    date: '2026-08-20',
    features: [
      'Statistics PDF Report - Export your statistics as a printable PDF with charts, ideal for sharing with a spiritual director',
    ],
    fixes: ['fixed unmount crash when navigating between screens', 'improved error screen with technical details'],
  },
  {
    version: '1.5.0',
    date: '2026-06-24',
    features: [
      'Release Notes - Long-press version in settings to view release history',
      'Long-Press Habit Edit - Long-press a habit to open the edit screen',
      'Active Partnerships - New statistic tracking active partnerships',
      'Today/Yesterday Toggle - Switch between today and yesterday in latest stats',
    ],
    fixes: [
      'fixed user data not saved on signup',
      'self-heal missing user records on app load',
      'restricted role changes via Firestore rules',
    ],
  },
  {
    version: '1.4.0',
    date: '2026-02-23',
    major: true,
    features: [
      'Delete Ended Habits - Can now delete habits from statistics view',
      'Bundle Selection - Choose which habits to include when adding a bundle',
      'Chart Layout Fixes - Improved mobile chart display',
      'App Statistics - Hourly app usage evaluation',
    ],
    fixes: ['fixed aggregation time window', 'fixed user loading'],
  },
  {
    version: '1.3.2',
    date: '2026-02-18',
    features: ['Lent Package - Added Lent habit bundle'],
  },
  {
    version: '1.3.1',
    date: '2025-12-17',
    features: [
      'Time Frame Fixes - Fixed statistics time frame calculations',
      'Reading Tracking - Store completed readings to DB',
    ],
  },
  {
    version: '1.3.0',
    date: '2025-12-05',
    major: true,
    features: [
      'Daily Reading - New screen for daily spiritual reading with markdown support',
      'Habit Bundles - Add predefined groups of habits at once',
      'Advent Theme - Seasonal theme with auto-enforcement',
      'Statistic Time Frames - View statistics by week/month/all time',
      'Screen Time Habit - New quantity-based habit for screen time tracking',
      'French Descriptions - Improved French translations',
      'Performance Improvements - Faster statistics loading',
    ],
    fixes: [
      'fixed password reset screen',
      'fixed reading done detection',
      'fixed screen time habit config',
      'fix for empty habits',
    ],
  },
  {
    version: '1.2.4',
    date: '2025-04-29',
    features: [
      'Special Days - Support for custom recurring days (e.g., first Friday of the month)',
      'Android Support - Added Android app files and Google Play integration',
      'Chart Tooltips - Improved tooltip display',
    ],
  },
  {
    version: '1.2.3',
    date: '2025-03-26',
    features: [
      'Target Direction - Track habits you want to reduce (not just increase)',
      'Description Screen - New app description/about screen',
    ],
    fixes: ['fixed week calculation', 'fixed target evaluation'],
  },
  {
    version: '1.2.2',
    date: '2025-03-15',
    features: ['Legal Terms - Added privacy policy and terms'],
  },
  {
    version: '1.2.1',
    date: '2025-03-12',
    features: [
      'Account Deletion - Users can delete their account',
      'Target Evaluation - Choose between average vs. final value tracking',
      'Partnership Ended State - Better partnership lifecycle handling',
      'Pending Habits Bubble - Visual indicator for pending habits',
      'Performance Improvements - Deferred statistic calculation',
    ],
    fixes: ['fixed date selector auto scroll', 'fixed target for ended habits', 'pending habits fix'],
  },
  {
    version: '1.2.0',
    date: '2025-03-11',
    major: true,
    features: [
      'Dark Mode - Full dark theme support',
      'Offline Support - App works without internet connection',
      'Home Screen Install - PWA "Add to Home Screen" support',
    ],
    fixes: ['offline fix', 'fixed week number'],
  },
  {
    version: '1.1.0',
    date: '2025-03-08',
    major: true,
    features: [
      'Habit Edit Screen - Edit, end, reset, or delete habits',
      'Week/Month Days - Track habits on specific days (e.g., every Monday)',
      'Italian Translation - Fixed Italian translations',
      'Update Modal - Notify users of app updates',
    ],
    fixes: ['fixed midnight records', 'fixed startup flicker'],
  },
  {
    version: '1.0.1',
    date: '2025-03-07',
    features: [
      'Custom Habits - Create your own habits (not just predefined)',
      'Weekly/Monthly Statistics - Statistics for different frequencies',
      'Partner Improvements - Better partner handling and display',
      'Password Reset - Custom password reset UI',
      'Non-Boolean Habits - Support for quantity and rating habits',
      'Closable Statistics - Collapse/expand habit statistics',
    ],
    fixes: ['fixed modal close', 'French translation fixes', 'fixed error screen', 'fixed weekly/monthly amounts'],
  },
  {
    version: '1.0.0',
    date: '2025-03-05',
    major: true,
    features: [
      'Initial Release - Core habit tracking functionality',
      'Multi-language - German, French, Italian, English',
      'Authentication - Email/password login',
      'Partner System - Share progress with partners',
      'Basic Statistics - Charts and progress tracking',
    ],
  },
];
